import { useParams } from 'react-router-dom'

import Page from '@/components/content/Page'
import { Translation } from '@/components/i18n/Translation'

import { useTranslation } from '../i18n/hooks'

import InjuryReport from './InjuryReport'

import './InjuryReportPage.styles.scss'

export const InjuryReportPage = () => {
  const params = useParams()
  const id = Number(params.id)
  const translate = useTranslation()

  if (isNaN(id)) throw Error(translate('Injury report ID is not a number!'))

  return (
    <Page className="injury-report-page">
      <h1>
        <Translation id="Injury Report #{injuryReportId}" injuryReportId={String(id)} />
      </h1>

      <InjuryReport />
    </Page>
  )
}
